var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_693_13264",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_693_13264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.33335V7.33335H10V6.00002H12V4.00002H13.3333V6.00002H15.3333V7.33335H13.3333V9.33335H12ZM6 8.00002C5.26667 8.00002 4.63889 7.73891 4.11667 7.21669C3.59445 6.69446 3.33334 6.06669 3.33334 5.33335C3.33334 4.60002 3.59445 3.97224 4.11667 3.45002C4.63889 2.9278 5.26667 2.66669 6 2.66669C6.73334 2.66669 7.36112 2.9278 7.88334 3.45002C8.40556 3.97224 8.66667 4.60002 8.66667 5.33335C8.66667 6.06669 8.40556 6.69446 7.88334 7.21669C7.36112 7.73891 6.73334 8.00002 6 8.00002ZM0.666672 13.3334V11.4667C0.666672 11.0889 0.763894 10.7417 0.958338 10.425C1.15278 10.1084 1.41112 9.86669 1.73334 9.70002C2.42223 9.35558 3.12223 9.09724 3.83334 8.92502C4.54445 8.7528 5.26667 8.66669 6 8.66669C6.73334 8.66669 7.45556 8.7528 8.16667 8.92502C8.87778 9.09724 9.57778 9.35558 10.2667 9.70002C10.5889 9.86669 10.8472 10.1084 11.0417 10.425C11.2361 10.7417 11.3333 11.0889 11.3333 11.4667V13.3334H0.666672ZM2.00001 12H10V11.4667C10 11.3445 9.96945 11.2334 9.90834 11.1334C9.84723 11.0334 9.76667 10.9556 9.66667 10.9C9.06667 10.6 8.46112 10.375 7.85001 10.225C7.23889 10.075 6.62223 10 6 10C5.37778 10 4.76112 10.075 4.15 10.225C3.53889 10.375 2.93334 10.6 2.33334 10.9C2.23334 10.9556 2.15278 11.0334 2.09167 11.1334C2.03056 11.2334 2.00001 11.3445 2.00001 11.4667V12ZM6 6.66669C6.36667 6.66669 6.68056 6.53613 6.94167 6.27502C7.20278 6.01391 7.33334 5.70002 7.33334 5.33335C7.33334 4.96669 7.20278 4.6528 6.94167 4.39169C6.68056 4.13058 6.36667 4.00002 6 4.00002C5.63334 4.00002 5.31945 4.13058 5.05834 4.39169C4.79723 4.6528 4.66667 4.96669 4.66667 5.33335C4.66667 5.70002 4.79723 6.01391 5.05834 6.27502C5.31945 6.53613 5.63334 6.66669 6 6.66669Z",
    fill: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.1bf344c9f54d75fc8ebdf0f3b48e98a3.svg";
export { ForwardRef as ReactComponent };